import type { RootState } from 'features/app/store/store';
import { VrsRedirectTarget } from 'features/app/store/app/enums/vrsRedirectTarget';

export const isRnsConnectionSuccessSelector = ({ app }: RootState) =>
  app.isRnsConnectionSuccess;

export const isInnerLoadingSelector = ({ app }: RootState) =>
  app.isInnerLoading;

export const selectIsAppUnloading = ({ app }: RootState) => app.isUnloading;

export const selectIsRnsConnectionClosed = ({ app }: RootState) =>
  app.isRnsConnectionClosed;

export const selectIsTokenSetOnHeaders = ({ app }: RootState) =>
  app.isTokenSetOnHeaders;

export const selectIsCognitoForcedLogoutRequested = ({ app }: RootState) =>
  app.isCognitoForcedLogoutRequested;

export const selectPendingVrsRedirect = ({ app }: RootState) =>
  app.pendingVrsRedirect;

export const selectPendingVrsRedirectTarget = ({ app }: RootState) =>
  app.pendingVrsRedirect?.target ?? null;

export const selectInCenterTeamingNoticeSnapshot = ({ app }: RootState) =>
  app.pendingVrsRedirect?.target === VrsRedirectTarget.InCenterTeamingNotice
    ? app.pendingVrsRedirect.snapshot
    : null;
